import { Backdrop } from '@mui/material';
// import CircularProgress from '@material-ui/core/CircularProgress';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';

const NVBackdrop = () => {
  // debugger
  const progressState = useSelector(state => state?.backdrop?.progress);
  // const [open, setOpen] = useState(progressState);

  return (
    <>
      <Backdrop
        sx={{
          zIndex: theme => theme.zIndex.modal + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
        }}
        open={progressState}
      >
        <CircularProgress />
      </Backdrop>
    </>
  );
};

export default NVBackdrop;
